export const FRAME_TYPE = {
    SIGNATURE_1: 0x0100,
    SIGNATURE_2: 0x0200,
    BLOCK_ID_NAME: 0x0300,
    BLOCK_FORMAT: 0x0400,
    BLOCK_NAMES: 0x0500,
    DIVIDER: 0xff00,
};
export const SCALAR_TYPE = {
    BYTE: 'B',
    WORD: 'W',
    LONG: 'L',
    STRING: 'S',
    OPERATION: 'A',
};
//# sourceMappingURL=types.js.map